
export default function FinalCTA() {
  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5d917f74a46c1f832218248cb6cfdd55.jpg"
          alt="Horizonte de Nova York"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <div className="absolute -top-8 -left-8 w-24 h-24 border-t-4 border-l-4 border-[#D4AF37] opacity-50"></div>
        <div className="absolute -top-8 -right-8 w-24 h-24 border-t-4 border-r-4 border-[#D4AF37] opacity-50"></div>
        <div className="absolute -bottom-8 -left-8 w-24 h-24 border-b-4 border-l-4 border-[#D4AF37] opacity-50"></div>
        <div className="absolute -bottom-8 -right-8 w-24 h-24 border-b-4 border-r-4 border-[#D4AF37] opacity-50"></div>

        <p className="text-[#D4AF37] text-base uppercase tracking-[0.3em] font-semibold mb-6">
          Sua Viagem Está Esperando
        </p>

        <h2 className="text-3xl lg:text-4xl xl:text-5xl font-serif font-bold leading-tight mb-12">
          Transforme Sua Viagem a Nova York em uma
          <br />
          <span className="text-[#D4AF37]">Experiência PremierNY</span> Inesquecível
        </h2>

        <div className="flex flex-col items-center gap-5">
          <a
            href="#packages"
            className="px-8 py-4 bg-[#D4AF37] text-black font-bold text-base rounded-full hover:bg-[#C5A028] transition-all duration-300 shadow-2xl flex items-center gap-3 group whitespace-nowrap"
          >
            Quero viajar com a PremierNY
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform"></i>
          </a>

          <div className="w-px h-6 bg-gradient-to-b from-[#D4AF37] to-transparent"></div>

          <a
            href="https://wa.me/16466330270"
            target="_blank"
            rel="noopener noreferrer"
            className="px-7 py-3 border-2 border-white text-white font-bold text-base rounded-full hover:bg-white hover:text-black transition-all duration-300 flex items-center gap-2 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Converse conosco pelo WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
